import React, { createContext, useContext, useEffect, useRef } from "react";
import {
  Route,
  Routes,
  BrowserRouter as Router,
  useNavigate,
} from "react-router-dom";
import Login from "./components/Login";
import AdminPanel from "./components/AdminPanel";
import Footer from "./components/Footer";
import UserDetail from "./components/UserDetail";
import UserProfile from "./components/UserProfile";
import "./App.css";

import GenerateInvoice from "./components/GenerateInvoice";
import GenerateCompanyInvoice from "./components/GenerateCompanyInvoice";
import CompanyInvoiceList from "./components/CompanyInvoiceList";
import CompanyInvoiceDetail from "./components/CompanyInvoiceDetail";
import AddEmployee from "./components/AddEmployee";
import EditEmployee from "./components/EditEmployee";
import InvoiceList from "./components/InvoiceList";
import InvoiceDetail from "./components/InvoiceDetail";
import MultipleInvoiceDetail from "./components/multipleDetail";
import PageNotFound from "./components/PageNotFound";
//import {ProtectedRoute, useAuth } from './auth/auth';

// Import Firebase
import firebase from "firebase/compat/app"; // Firebase app
import "firebase/compat/storage"; // Firebase storage

import axios from "axios";
import Dashboard from "./components/Dashboard";
import PaySlipMetaData from "./components/PaySlipMetaData";
import EditInvoice from "./components/EditInvoice";
import EmployeeYtd from "./components/EmployeeYtd";
import Invoices from "./components/Invoices";
import GenerateInvoiceNew from "./components/GenerateInvoiceNew";
import PreviewInvoiceNew from "./components/PreviewInvoiceNew";
import ManageAccounts from "./components/ManageAccounts";
import AccountForm from "./components/AccountForm";
import { Toaster } from "sonner";
import { clearSession } from "./services/AuthService";

const apiUrl = process.env.REACT_APP_API_URL;
// Create an authentication context
const AuthContext = createContext();

// AuthProvider component
const AuthProvider = ({ children }) => {
  // Your authentication logic goes here
  const useAuth = () => {
    const navigate = useNavigate();
    useEffect(() => {
      const token = localStorage.getItem("token");

      if (!token) {
        // Redirect to the login page if there is no token
        navigate("/");
      } else {
        axios
          .get(`${apiUrl}/verifyToken`, {
            headers: {
              auth: token,
            },
          })
          .then((response) => {
            const { status, role, accountId, email, fullname } = response.data;
            if (status === 1) {
              if (role) localStorage.setItem("user_role", role);
              if (accountId != null) {
                localStorage.setItem("account_id", String(accountId));
              }
              if (email) localStorage.setItem("user_email", email);
              if (fullname) localStorage.setItem("user_name", fullname);
              window.dispatchEvent(new Event("user-session-updated"));
            } else {
              clearSession();
              navigate("/");
            }
          })
          .catch((error) => {
            const message = error.response?.data?.message;
            if (message) {
              sessionStorage.setItem("login_message", message);
            }
            clearSession();
            navigate("/");
          });
      }
    }, []);
  };

  // Return the AuthProvider with the useAuth hook and children
  return (
    <AuthContext.Provider value={{ useAuth }}>{children}</AuthContext.Provider>
  );
};

// ProtectedRoute component — auth only; permissions are enforced in-page via dialogs
const ProtectedRoute = ({ element }) => {
  const { useAuth } = useContext(AuthContext);
  useAuth();
  return element;
};

const App = () => {
  // Firebase configuration
  const firebaseConfig = {
    apiKey: "AIzaSyBM99DvuYzTNU9UmQ7gdMO7Kg5VaBCx9OI",
    authDomain: "surplus-staff-payroll-system.firebaseapp.com",
    projectId: "surplus-staff-payroll-system",
    storageBucket: "surplus-staff-payroll-system.appspot.com",
    messagingSenderId: "491375292675",
    appId: "1:491375292675:web:af214a155e678b9faeb936",
    measurementId: "G-6ZGNGB9NXS",
  };

  // Initialize Firebase
  if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
  }

  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Toaster richColors />
          <Routes>
            <Route path="/" element={<Login />} />
            {/* <Route path="/manageEmployee" element={<AdminPanel />} /> */}
            <Route
              path="/manageEmployee"
              element={<ProtectedRoute element={<AdminPanel />} />}
            />
            <Route
              path="/employeeYtd"
              element={<ProtectedRoute element={<EmployeeYtd />} />}
            />
            <Route
              path="/userDetail"
              element={<ProtectedRoute element={<UserDetail />} />}
            />
            <Route
              path="/generateInvoice"
              element={<ProtectedRoute element={<GenerateInvoice />} />}
            />
            <Route
              path="/generateInvoiceNew"
              element={<ProtectedRoute element={<GenerateInvoiceNew />} />}
            />
            <Route
              path="/previewInvoice"
              element={<ProtectedRoute element={<PreviewInvoiceNew />} />}
            />
            <Route
              path="/editInvoice"
              element={<ProtectedRoute element={<EditInvoice />} />}
            />
            <Route
              path="/dashboard"
              element={<ProtectedRoute element={<Dashboard />} />}
            />
            {/* uncomment below 3 for company invoice generate, list and detail section */}

            {/* <Route
            path="/generateCompanyInvoice"
            element={<ProtectedRoute element={<GenerateCompanyInvoice />} />}
          />
           <Route
            path="/companyInvoiceList"
            element={<ProtectedRoute element={<CompanyInvoiceList />} />}
          />
          <Route
            path="/companyInvoiceDetail"
            element={<ProtectedRoute element={<CompanyInvoiceDetail />} />}
          /> */}

            <Route
              path="/invoiceList"
              element={<ProtectedRoute element={<InvoiceList />} />}
            />
            <Route
              path="/invoiceDetail"
              element={<ProtectedRoute element={<InvoiceDetail />} />}
            />
            <Route
              path="/multipleInvoiceDetail"
              element={<ProtectedRoute element={<MultipleInvoiceDetail />} />}
            />
            <Route
              path="/addEmployee"
              element={<ProtectedRoute element={<AddEmployee />} />}
            />
            <Route
              path="/editEmployee"
              element={<ProtectedRoute element={<EditEmployee />} />}
            />
            <Route
              path="/userProfile"
              element={<ProtectedRoute element={<UserProfile />} />}
            />
            <Route
              path="/payslipmetadata"
              element={<ProtectedRoute element={<PaySlipMetaData />} />}
            />
            <Route
              path="/invoices"
              element={<ProtectedRoute element={<Invoices />} />}
            />
            <Route
              path="/myAccount"
              element={<ProtectedRoute element={<AccountForm />} />}
            />
            <Route
              path="/manageAccounts"
              element={<ProtectedRoute element={<ManageAccounts />} />}
            />
            <Route
              path="/manageAccounts/add"
              element={<ProtectedRoute element={<AccountForm />} />}
            />
            <Route
              path="/manageAccounts/edit/:accountId"
              element={<ProtectedRoute element={<AccountForm />} />}
            />
            <Route path="/*" element={<PageNotFound />} />
          </Routes>
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
};

export default App;
